import { render } from "./SingleBulletin.vue?vue&type=template&id=1850fd99"
import script from "./SingleBulletin.vue?vue&type=script&lang=js"
export * from "./SingleBulletin.vue?vue&type=script&lang=js"

import "./SingleBulletin.vue?vue&type=style&index=0&id=1850fd99&lang=css"

import exportComponent from "C:\\Users\\surface\\3D Objects\\Work\\schools\\inspire-school\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__